import { createSelector } from '@reduxjs/toolkit';
import { useRouter } from 'preact-router';

import Redirect from '@/components/Redirect';
import { AppState, useSelector } from '@/redux/helper';
import { createSortedHabitatsSelector } from '@/redux/selectors/habitats';

const selectHabitatSlug = createSelector(
  createSortedHabitatsSelector(),
  (_: AppState, zooSlug: string | undefined) => zooSlug,
  (habitats, zooSlug) => {
    return zooSlug ? habitats.find((habitat) => habitat.zoo.slug === zooSlug)?.slug : habitats[0]?.slug;
  },
);

const EmbeddedHabitats = () => {
  const [{ matches }] = useRouter();
  const habitatSlug = useSelector((state) => selectHabitatSlug(state, matches?.zoo));

  if (!habitatSlug) {
    return null;
  }

  return <Redirect to={`/embed/habitats/${habitatSlug}`} />;
};

export default EmbeddedHabitats;
